import React from 'react';
import { ELSPageLoader } from '@els/els-ui-common-react';
import IsRender from '../../components/is-render/IsRender.component';
import { RecordObject } from '../../models/common.models';

// Note: If you use this before connect it will not work
type WithPageLoaderProps = {
  showPageLoader?: boolean;
  [key: string]: unknown;
};

// eslint-disable-next-line react/display-name
const withPageLoader = <P extends RecordObject>(WrappedComponent: React.ComponentType<P>): React.ComponentType<P & WithPageLoaderProps> => {
  const Wrapper = (wrappedProps: P & WithPageLoaderProps): React.ReactElement => {
    const { showPageLoader } = wrappedProps;
    return (
      <>
        <IsRender isRender={!!showPageLoader}>
          <ELSPageLoader />
        </IsRender>
        <WrappedComponent {...(wrappedProps as P)} />
      </>
    );
  };

  Wrapper.displayName = `withPageLoader(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return Wrapper;
};

export default withPageLoader;
